module.exports = "<div class=gmc-select-option ng-click=$ctrl.onClick($event) ng-show=$ctrl.isVisible ng-class=\"{active: $ctrl.isSelected}\" ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-select-2/components/gmc-select-option.component.html
// module id = 847
// module chunks = 31